import DepositTransactions from "@/pages/components/DepositTransactionList";
import {Box, Card} from "@mui/material";
import useMobileDetect from "next-device-detection";
import classes from './TransList.module.css'
import mobileClasses from './mobile.module.css'
import {getUrlParams} from "@/utils/utils.js";

function AssetsTransList() {
  const detectMobile = useMobileDetect();
  return (
    <>
      {
        detectMobile.isMobile &&
        <Box className={mobileClasses.root}>
          <DepositTransactions bussinessType={37} isCompact={false} pageable/>
        </Box>
      }
    </>

  );
}

export default AssetsTransList;
